const companyTypeC = {
    'Animal Production': [
        { name: 'Cattle Ranching & Farming' },
        { name: 'Hog & Pig Farming' },
        { name: 'Poultry & Egg Production' },
        { name: 'Sheep & Goat Farming' },
        { name: 'Animal Aquaculture' },
        { name: 'Other Animal Production' }
    ],
    'Crop Production': [
        {
            name: 'Oilseed & Grain Farming'
        },
        {
            name: 'Vegetable & Melon Farming'
        },
        {
            name: 'Fruit & Tree Nut Farming'
        },
        {
            name: 'Greenhouse, Nursery & Floriculture Production'
        },
        {
            name: 'Other Crop Farming'
        }
    ],
    'Forestry and Logging': [
        {
            name: 'Timber & Tract Operations'
        },
        {
            name: 'Forest Nurseries & Gathering of Forest Products'
        },
        {
            name: 'Logging'
        }
    ],
    'Fishing, Hunting & Trapping': [
        {
            name: 'Fishing & Fishery'
        },
        {
            name: 'Hunting & Trapping'
        }
    ],
    'Support Activities For Agriculture': [
        {
            name: 'Support Activities For Animal Production'
        },
        {
            name: 'Support Activities For Crop Production'
        },
        {
            name: 'Support Activities For Forestry'
        },
        {
            name: 'Support Activities For Fishing & Fisheries'
        }
    ],
    'Oil & Gas Extraction': [
        {
            name: 'Crude & Gas Exploration'
        },
        {
            name: 'Drilling/Completing & Equipping Wells'
        },
        {
            name: 'Oil & Gas Shipment'
        },
        {
            name: 'Crude Refining'
        },
        {
            name: 'Natural Gas Production'
        },
        {
            name: 'Support Activities For Oil & Gas'
        }
    ],
    Mining: [
        {
            name: 'Coal Mining'
        },
        {
            name: 'Metal Ore Mining'
        },
        {
            name: 'Non-metallic Mineral Mining'
        },
        {
            name: 'Quarrying'
        },
        {
            name: 'Support Activities For Mining'
        }
    ],
    'Construction of Buildings': [
        {
            name: 'Residential Building Construction'
        },
        {
            name: 'Nonresidential Building Contruction'
        }
    ],
    'Heavy & Civil Engineering Construction': [
        {
            name: 'Utility System Construction'
        },
        {
            name: 'Land Subdivision'
        },
        {
            name: 'Highway, Street & Bridge Construction'
        },
        {
            name: 'Other Heavy & Civil Engineering Construction'
        }
    ],
    'Specialty Trade Contractors': [
        {
            name: 'Foundation, Structure & Building Exter. Contractors'
        },
        {
            name: 'Building Equipment Contractors'
        },
        {
            name: 'Building Finishing Contractors'
        },
        {
            name: 'Other Specialty Trade Contractors'
        }
    ],
    'Food Manufacturing': [
        {
            name: 'Animal Food Manufacturing'
        },
        {
            name: 'Grain & Oilseed Milling'
        },
        {
            name: 'Sugar & Confectionery Products Manufacturing'
        },
        {
            name: 'Fruit & Veg. Preserving Food Manufacturing'
        },
        {
            name: 'Soup, Sauces & Stew Packaging'
        },
        {
            name: 'Diary Product Manufacturing'
        },
        {
            name: 'Animal Slaughtering & Processing'
        },
        {
            name: 'Seafood Product Preparation & Packaging'
        },
        {
            name: 'Bakeries, Chip, Fries, Snacks & Crisp Manufacturing'
        },
        {
            name: 'Other Food Manufacturing'
        }
    ],
    'Beverages Manufacturing': [
        {
            name: 'Non-alcoholic Bev., Juice & Soft drinks Manufacturing'
        },
        {
            name: 'Wine Manufacturing'
        },
        {
            name: 'Beer & Malt Manufacturing'
        },
        {
            name: 'Distilled Beverages Manufacturing'
        }
    ],
    'Tobacco Manufacturing': [
        {
            name: 'Tobacco Stemming & Re-drying'
        },
        {
            name: 'Cigarettes & Cigar Manufacturing'
        }
    ],
    'Textile Mills': [
        {
            name: 'Fiber, Yarn & Thread Mills'
        },
        {
            name: 'Fabric Mills'
        },
        {
            name: 'Textiles & fabric Finishing and Fabric Coating Mills'
        }
    ],
    'Textile Product Mills': [
        {
            name: 'Textile Furnishing Mills'
        },
        {
            name: 'Other Textiles product Mills'
        }
    ],
    'Apparel Manufacturing': [
        {
            name: 'Apparel Knitting Mills'
        },
        {
            name: 'Cut & Sew Apparel Manufacturing'
        },
        {
            name: 'Apparel Accessories & Other Apparel Manufacturing'
        }
    ],
    'Leather & Allied Product Manufacturing': [
        {
            name: 'Leather & Hide Tanning Finishing'
        },
        {
            name: 'Footwear Manufacturing'
        },
        {
            name: 'Leather, Substitutes & Allied Prod. Manufacturing'
        }
    ],
    'Wood Product Manufacturing': [
        {
            name: 'Sawmills & Wood Preservatives'
        },
        {
            name: 'Plywood & Wood Products Manufacturing'
        },
        {
            name: 'Other wood Product Manufacturing'
        }
    ],
    'Paper Manufacturing': [
        {
            name: 'Pulp, Paper and Paperboard Mills'
        },
        {
            name: 'Converted Paper Product Manufacturing'
        }
    ],
    'Printing and Related Support Activities': [
        {
            name: 'Newspaper & Magazine Printing'
        },
        {
            name: 'Educational Books & Manual Printing'
        },
        {
            name: 'Labels Printing'
        },
        {
            name: 'Business, Promotional & Marketing Mat. Printing'
        },
        {
            name: 'Printing Support Activies'
        }
    ],
    'Chemicals Manufacturing': [
        {
            name: 'Basic Chemical Manufacturing'
        },
        {
            name: 'Resin, Syn. Rubber, Syn. Fibers & Filaments Manufacturing'
        },
        {
            name: 'Pesticide, Fertilizer & Other Agric. Chemical  Manufacturing'
        },
        {
            name: 'Paint Coating & Adhesive Manufacturing'
        },
        {
            name: 'Soap, Cleaning Compound & Toilet Prod. Manufacturing'
        },
        {
            name: 'Other Chemical Products & Preparation  Manufacturing'
        }
    ],
    'Plastics & Rubber Products Manufacturing': [
        {
            name: 'Plastics Products Manufacturing'
        },
        {
            name: 'Rubber Products Manufacturing'
        }
    ],
    'Non-metallic Mineral Product Manufacturing': [
        {
            name: 'Clay Products & Refractory Manufacturing'
        },
        {
            name: 'Glass & Glass Products Manufacturing'
        },
        {
            name: 'Cement & Concrete Products Manufacturing'
        },
        {
            name: 'Lime & Gypsum Products Manufacturing'
        },
        {
            name: 'Other Non-Metallic Mineral Product Manufacturing'
        }
    ],
    'Primary Metal Manufacturing': [
        {
            name: 'Iron, Steel Mills & Ferroalloy Manufacturing'
        },
        {
            name: 'Steel Products Manufacturing From Purchased Steel'
        },
        {
            name: 'Alumina & Aluminium Production & Processing'
        },
        {
            name: 'Non-ferrous Metal Prod. & Processing Foundries'
        }
    ],
    'Machinery Manufacturing': [
        {
            name: 'Agric., Construction & Mining Machinery Manufacturing'
        },
        {
            name: 'Industrial Machinery Manufacturing'
        },
        {
            name: 'Commercial & Service Industry Machinery Manufacturing'
        },
        {
            name: 'Ventilation, Heating, AC, & Commercial Refrigeration Manufacturing'
        },
        {
            name: 'Metalworking Machinery Manufacturing'
        },
        {
            name: 'Engine, Turbine & Power Transmission Equipment Manufacturing'
        },
        {
            name: 'Other General Purpose Machinery Manufacturing'
        }
    ],
    'Computer & Electronic Products Manufacturing': [
        {
            name: 'Computer & Peripheral Equipment Manufacturing'
        },
        {
            name: 'Communications Equipment Manufacturing'
        },
        {
            name: 'Audio & Video Equipment Manufacturing'
        },
        {
            name: 'Semiconductor & Other Electronic Component Manufacturing'
        },
        {
            name: 'Navigational, Measuring & Control Instruments Manufacturing'
        },
        {
            name: 'Electro-medical Instrument Manufacturing'
        },
        {
            name: 'Manufacturing & Reproducing Magnetic & Optical Media'
        }
    ],
    'Electrical Equipment, Appliance & Component': [
        {
            name: 'Electric Lighting Equipment Manufacturing'
        },
        {
            name: 'Household Appliance Manufacturing'
        },

        {
            name: 'Electrical Equipment Manufacturing'
        },
        {
            name: 'Other Electrical Equipment & Component Manufacturing'
        }
    ],
    'Transportation Equipment Manufacturer': [
        {
            name: 'Motor Vehicle Manufacturing'
        },
        {
            name: 'Motor Vehicle Manufacturing'
        },

        {
            name: 'Motor Vehicle Body & Trailer Manufacturing'
        },
        {
            name: 'Motor Vehicle Parts Manufacturing'
        },

        {
            name: 'Aerospace Product & Parts Manufacturing'
        },

        {
            name: 'Railroad Rolling Stock Manufacturing'
        },

        {
            name: 'Ship & Boat Building'
        },
        {
            name: 'Other Transportation Equipment Manufacturing'
        }
    ],
    'Furniture & Related Products Manufacturer': [
        {
            name: 'Household, Institutional Furniture & Kitchen Cabinet Manufacturing'
        },
        {
            name: 'Office Furniture & Fixtures Manufacturing'
        },
        {
            name: 'Other Furniture Related Product Manufacturing'
        }
    ],
    'Medical Equipment Manufacturing': [
        {
            name: 'Medical Equipment Manufacturing'
        }
    ],
    'All Other Manufacturing': [
        {
            name: 'Sports Goods & Equipment Mnaufacturing'
        },
        {
            name: 'Children’s Toys Manufacturing'
        },
        {
            name: 'Perfume Manufacturing'
        },
        {
            name: 'Artificial Trees & Plants Manufacturing'
        },
        {
            name: 'Umbrella  Manufacturing'
        },
        {
            name: 'Wigs & Hair Pieces Manufacturing'
        },
        {
            name: 'Artificial Wreaths Manufacturing'
        },
        {
            name: 'Candle Manufacturing'
        },
        {
            name: 'Jewelry Manufacturing'
        },
        {
            name: 'Office Supplies Manufacturing'
        },
        {
            name: 'Sign & Signage Manufacturing'
        },
        {
            name: 'Gasket, Packaging & Sealing Device Manufacturing'
        },
        {
            name: 'Musical Equipment Manufacturing'
        },
        {
            name: 'Fasteners, Buttons, Pin, Needles Manufacturing'
        },
        {
            name: 'Brooms, Brushes & Mops Manufacturing'
        },
        {
            name: 'Burial Caskets Manufacturing'
        },
        {
            name: 'Glass Ornaments & Glass Shades Manufacturing'
        },
        {
            name: 'Party, Salon & Office Chairs Manufacturing'
        },
        {
            name: 'Matches & Lighter Manufacturing'
        },
        {
            name: 'Combs, Brushes & Curlers Manufacturing'
        },
        {
            name: 'Electrical Clippers Manufacturing'
        },
        {
            name: 'Mirror Manufacturing'
        },

        {
            name: 'Cleaning & Deodorizing Agents Manufacturing'
        },
        {
            name: 'Picture Frame Manufacturing'
        }
    ],
    'Durable Goods Wholesalers': [
        {
            name: 'Wholesalers of Motor Vehicle, Motor Vehicle Parts & Suppliers'
        },
        {
            name: 'Wholesalers & Suppliers of Furniture & Home Furnishing'
        },
        {
            name: 'Wholesalers & Suppliers of Wood, Cement & Other Construction Materials'
        },
        {
            name: 'Wholesalers & Suppliers of Professional & Commercial Equipment'
        },
        {
            name: 'Wholesalers & Suppliers of Metal & Mineral'
        },
        {
            name: 'Wholesalers & Suppliers of Electrical & Electronic Goods'
        },
        {
            name: 'Wholesalers & Suppliers of  Hardware, Plumbing & Heating Equipment'
        },
        {
            name: 'Wholesalers & Suppliers of Machinery Equipment'
        },
        {
            name: 'Wholesalers & Suppliers of Durable Miscellaneous Goods'
        }
    ],
    'Non-durable Goods Wholesalers': [
        {
            name: 'Wholesalers of Paper & Paper Products'
        },
        {
            name: 'Wholesalers of Drugs & Druggists Sundries'
        },
        {
            name: 'Wholesalers of Apparel, Ready-mades & Used Clothing'
        },
        {
            name: 'Wholesalers of Provisions, Groceries & Foodstuff'
        },
        {
            name: 'Wholesalers of Farm Products & Raw Materials'
        },
        {
            name: 'Wholesalers of Chemicals & Allied Products'
        },
        {
            name: 'Wholesalers of Petroleum & Petroleum Products'
        },
        {
            name: 'Wholesalers of Beer Wine & Dist. Alcoholic Beverages'
        },
        {
            name: 'Wholesalers of Miscellaneous Non-durable Goods'
        }
    ],
    'Wholesale Brokers & Agents': [
        {
            name: 'Brokers & Agents of Any Type of Durable Goods'
        },
        {
            name: 'Brokers & Agents of Any Type of Non-Durable Goods'
        }
    ],
    'Motor Vehicles & Parts Dealers': [
        {
            name: 'Brand New Automobile Dealers'
        },
        {
            name: 'Used Vehicle dealers'
        },
        {
            name: 'Industrial & Heavy Duty Vehicles Dealers'
        },
        {
            name: 'Automotive, Parts, Accessories & Parts Dealers'
        }
    ],
    'Furniture & Home Furnishing Stores': [
        {
            name: 'All Furniture Dealers'
        },
        {
            name: 'Home Furnishing Dealers'
        }
    ],
    'Electronics & Appliance Dealers': [
        {
            name: 'IT & Telecommunications Equipment Dealers'
        },
        {
            name: 'Consumer Electrical Equipment Dealers'
        },
        {
            name: 'Consumer Electronic Equipment Dealers'
        }
    ],
    'Building Materials Dealers & Suppliers': [
        {
            name: 'Natural Building Materials Dealers & Suppliers '
        },
        {
            name: 'Man- Made Building Materials Suppliers & Dealers'
        }
    ],
    'Health & Personal Care Products Dealers': [
        {
            name: 'Cosmetics & All Personal Care Products'
        },
        {
            name: 'Herbal, Vitamins & Traditional Medicines Dealers'
        }
    ],
    'Gas Re-fillers & Petrol Stations': [
        {
            name: 'Gas Filling Station'
        },
        {
            name: 'Gas Re-filler'
        },
        {
            name: 'Gas & Petrol Filling Station'
        }
    ],
    'Clothing, Accessories & Luggage Dealers': [
        {
            name: 'Clothing Stores'
        },

        {
            name: 'Shoes Stores'
        },

        {
            name: 'Jewelry Stores'
        },

        {
            name: 'Luggage, Bags & Leather Goods'
        }
    ],
    'Sporting Goods Retailers': [
        {
            name: 'Sporting Goods (Equipments)'
        },

        {
            name: 'Online Games & Gaming'
        }
    ],
    'Hobby & Music Retailers': [
        {
            name: 'Musical Instruments Retailers'
        },
        {
            name: 'Online Music Stores'
        },
        {
            name: 'Online Video Stores'
        },
        {
            name: 'Online Books, Magazines & News'
        },
        {
            name: 'Online Blogs & Forums '
        }
    ],
    'General Merchandise (Stores)': [
        {
            name: 'Department Stores'
        },
        {
            name: 'Electronic Department Stores'
        },
        {
            name: 'Office Supplies & Stationery Stores'
        },
        {
            name: 'Gift Stores'
        },
        {
            name: 'Used Merchandise Stores'
        },
        {
            name: 'Household Goods Stores'
        },
        {
            name: 'Arts, Florists & Decorations Stores'
        }
    ],
    'General Merchandise (Online)': [
        {
            name: 'Electrical & Electronics Appliances Vendors'
        },
        {
            name: 'Office Supplies Vendors'
        },
        {
            name: 'Newspaper Vendors'
        },
        {
            name: 'Mobile Phone Recharge Cards Vendors'
        },
        {
            name: 'Electricity Recharge Cards Vendors'
        }
    ],
    'Refrigerated & Frozen Foods': [
        {
            name: 'Meat, Fish, Chicken, Prawns etc. Retails'
        },
        {
            name: 'Vegetables, Processed & Packaged Food Retails'
        },
        {
            name: 'Beverages, Fruits Juice & Soft Drinks Retails'
        },
        {
            name: 'Beer, Wines & Liquor'
        },
        {
            name: 'Ice Cream & Confectioneries  Retails'
        }
    ],
    'Shelf Groceries & Provisions': [
        {
            name: 'Retail Provision Store'
        },
        {
            name: 'Wholesale Provision Store'
        }
    ],
    'Air Transportation': [
        {
            name: 'Scheduled Air Transportation'
        },
        {
            name: 'Non Scheduled Air Transportation'
        }
    ],
    'Rail Transportation': [
        {
            name: 'Coach Rail Transportation '
        }
    ],
    'Water Transportation': [
        {
            name: 'Deep Sea & Coastal Transportation'
        },
        {
            name: 'Inland Water Transportaion'
        }
    ],
    'Truck Transportation': [
        {
            name: 'Specialized Freight Trucking'
        },
        {
            name: 'General Freight Trucking'
        }
    ],
    'Transit & Road Passenger Transportation': [
        {
            name: 'City Transit System'
        },
        {
            name: 'Inter State Transit System'
        },
        {
            name: 'Taxi & Limousine Services'
        },
        {
            name: 'Online Cab Hailing Service'
        },
        {
            name: 'School & Employee Bus Transportation'
        },
        {
            name: 'Charter Bus Transportation'
        },
        {
            name: 'Bike & Tricycle Transportation'
        }
    ],
    'Scenic & Sightseeing Transportation': [
        {
            name: 'Land Scenic & Sight Seeing Transportation'
        },
        {
            name: 'Water Scenic & Sight Seeing Transportation'
        }
    ],
    'Support Activities For Transportation': [
        {
            name: 'Air Traffic Control'
        },
        {
            name: 'Cargo Handling'
        },
        {
            name: 'Food Service'
        },
        {
            name: 'Ticket Sales'
        },
        {
            name: 'Towing Service'
        },
        {
            name: 'Reapairs & Engineering Service'
        }
    ],
    'Postal Service': [
        {
            name: 'National Postal Service'
        },
        {
            name: 'Local Courier, Delivery & Messenger Service'
        },
        {
            name: 'Statewide Courier, Delivery & Messenger Service'
        },
        {
            name: 'National Courier, Delivery & Messenger Service'
        },
        {
            name: 'International Courier, Delivery & Messenger Service'
        }
    ],
    'Warehousing & Storage': [
        {
            name: 'Cooperative Warehousing'
        },
        {
            name: 'Private Warehousing'
        },
        {
            name: 'Bonded Warehousing'
        },
        {
            name: 'Cold Storage Warehousing'
        },
        {
            name: 'Climate Controlled Warehousing'
        },
        {
            name: 'Distribution Center Warehousing'
        },
        {
            name: 'Export & Import Warehousing'
        },
        {
            name: 'Public Warehousing'
        },
        {
            name: 'Government Warehousing'
        }
    ],
    'Pipeline Transportation': [
        {
            name: 'Pipeline Transportation of Crude Oil & Petrol'
        },
        {
            name: 'Pipeline Transportation of Natural Gas'
        }
    ],
    'Electricity Provision': [
        {
            name: 'Electricity Generation'
        },
        {
            name: 'Electricity Distribution'
        },
        {
            name: 'Electricity Transmission'
        },
        {
            name: 'Solar/Inverter/Battery/Sales & Service'
        }
    ],
    'Natural Gas Distribution': [
        {
            name: 'Portable Cooking Gas Retailer'
        },
        {
            name: 'Welding Gas Retailer'
        }
    ],
    'Water, Sewage & Other Systems': [
        {
            name: 'Water Distribution'
        },
        {
            name: 'Borehole Drilling & Irrigation Systems'
        },
        {
            name: 'Sewage Disposal & Other Systems'
        }
    ],
    'Publishing Industries': [
        {
            name: 'Newspapers, Books & Periodicals'
        },
        {
            name: 'Software Publishers'
        }
    ],
    'Sound & Movie Production': [
        {
            name: 'Motion Picture, Movie & Shorts Production'
        },
        {
            name: 'All Sound Recording'
        }
    ],
    Broadcasting: [
        {
            name: 'Radio & TV Broadcasting'
        },
        {
            name: 'Cable TV & Subscription Programming'
        }
    ],
    'Internet Publishing & Broadcasting': [
        {
            name: 'Podcasting, Vlogging & Blogging'
        },
        {
            name: 'Music Streaming'
        },
        {
            name: 'Movie Streaming'
        },
        {
            name: 'Online Book Publishing & Sales'
        }
    ],
    Telecommunications: [
        {
            name: 'Wired Telecoms Providers'
        },
        {
            name: 'Wireless Telecoms Providers'
        },

        {
            name: 'Telecommunications Resellers'
        },
        {
            name: 'Satellite Telecommunications'
        },
        {
            name: 'Cable & Other Program Distributors'
        }
    ],
    'Data Processing & Hosting Service': [
        {
            name: 'Commercial Data Processing'
        },
        {
            name: 'Scientific Data Processing'
        },

        {
            name: 'Batch Processing'
        },
        {
            name: 'Online Processing'
        },

        {
            name: 'Real-Time Processing'
        },

        {
            name: 'Shared Hosting'
        },

        {
            name: 'Virtual Private Server(VPS)'
        },
        {
            name: 'Dedicated Server Hosting'
        },
        {
            name: 'Cloud Hosting'
        },

        {
            name: 'Managed Hosting'
        },
        {
            name: 'Colocation'
        }
    ],
    'Information Websites': [
        {
            name: 'Chatrooms'
        },
        {
            name: 'Forums'
        },
        {
            name: 'Libraries'
        },
        {
            name: 'Blogs'
        },
        {
            name: 'News Channels'
        },
        {
            name: 'Online Libraries'
        },
        {
            name: 'Search Portals'
        }
    ],
    'Monetary Authorities - Central Bank': [
        {
            name: 'Central Bank & Affiliates'
        },
        {
            name: 'Commercial Banking'
        },
        {
            name: 'Merchant Banking'
        },
        {
            name: 'Microfinance Banking'
        },
        {
            name: 'Mortgage Banking'
        },
        {
            name: 'Savings & Loans'
        },
        {
            name: 'Online/Mobile Banking'
        },
        {
            name: 'Investment Banking'
        },
        {
            name: 'Community Banking'
        },
        {
            name: 'Online Lending '
        },
        {
            name: 'Money Lendering'
        },
        {
            name: 'Thrift Banking'
        },
        {
            name: 'International Money Transfer Services'
        },
        {
            name: 'Online Savings Platforms'
        },
        {
            name: 'Financial Technology (Fintech) Platforms'
        }
    ],
    'Credit Intermediator Services': [
        {
            name: 'Depository Credit Intermediator'
        },
        {
            name: 'Nondepository Credit Intermediation'
        },
        {
            name: 'Activities Related to Credit Intermediation'
        }
    ],
    'Security Contracts/ Finacial Investments': [
        {
            name: 'Brokerage (Security & Commodity Contracts)'
        },
        {
            name: 'Security & Commodity Exchanges'
        },
        {
            name: 'Asset & Portfolio Management'
        }
    ],
    'Insurance Institutions': [
        {
            name: 'Insurance Carriers'
        },
        {
            name: 'Insurance Agents, Brokers & Underwriters'
        }
    ],
    'Funds & Trusts': [
        {
            name: 'Insurance & Employee Benefit Funds'
        },

        {
            name: 'Investment Pools & Funds'
        }
    ],
    'Real Estate': [
        {
            name: 'Lessors of Real Estate'
        },
        {
            name: 'Offices  of Real Estate Agents & Brokers '
        },
        {
            name: 'Real Estate Investment Trusts '
        }
    ],
    'Rental & Leasing Service': [
        {
            name: 'Vehicle Equipment Rental & Leasing '
        },
        {
            name: 'Consumer Goods & General  Rental '
        },
        {
            name: 'Commercial / Industrial Equipment & Machinery Leasing '
        }
    ],
    'Non-financial Asset Leasing': [
        {
            name: 'Patents, Trademarks, Franchise &  Brand Leasing '
        }
    ],
    'Professional, Scientific & Tech. Services': [
        {
            name: 'Legal  Services '
        },
        {
            name: 'Accounting ,Book-keeping, Tax Preparation & Payroll Services '
        },
        {
            name: 'Specialized Design Services '
        },
        {
            name: 'Architectural & Engineering Service '
        },
        {
            name: 'Computer Systems  & Software Engineering Design Services '
        },
        {
            name: 'Management, Scientific & Technical Consulting Service '
        },
        {
            name: 'Scientific Research & Dev. Service'
        },
        {
            name: 'Advertising & Advertisement  Related Services '
        }
    ],
    'Management of Companies & Enterprises': [
        {
            name: 'Financial Management'
        },
        {
            name: 'Marketing Management'
        },
        {
            name: 'Sales Management'
        },
        {
            name: 'Human Resource Management'
        },
        {
            name: 'Strategic Management'
        },
        {
            name: 'Production Management'
        },
        {
            name: 'Program & Project Management'
        },
        {
            name: 'Operations Management'
        },
        {
            name: 'Service Management'
        },
        {
            name: 'IT Management'
        },
        {
            name: 'Public Relations Management'
        },
        {
            name: 'Supply Chain Management'
        },
        {
            name: 'Procurement Management'
        },
        {
            name: 'Research & Development Management'
        },
        {
            name: 'Engineering Management'
        },
        {
            name: 'Design  Management'
        },
        {
            name: 'Quality Management'
        },
        {
            name: 'Risk Management'
        },
        {
            name: 'Facility Management'
        },
        {
            name: 'Innovation Management'
        },
        {
            name: 'Knowledge Management'
        },
        {
            name: 'Change Management'
        }
    ],
    'Administrative Support Services': [
        {
            name: 'Office Admin Services'
        },
        {
            name: 'Facilities Support Services'
        },
        {
            name: 'Employment Services'
        },
        {
            name: 'Business Support services'
        },
        {
            name: 'Travel & Reservation Services'
        },
        {
            name: 'Investigation & Security Services'
        },
        {
            name: 'Services to Buildings & Residences'
        }
    ],
    'Waste Management & Remediation Services': [
        {
            name: 'Waste Collection'
        },
        {
            name: 'Waste Treatment & Disposal'
        },
        {
            name: 'Cleanup, Decontamination & Sanitation Services'
        },
        {
            name: 'Construction Waste Disposal Services'
        }
    ],
    'Ambulatory Healthcare Services': [
        {
            name: 'Optometry & Optician Clinics'
        },
        {
            name: 'Dental Clinics'
        },
        {
            name: 'Public Health Centers'
        },
        {
            name: 'Private Health Centers'
        },
        {
            name: 'Medical & Diagnostics Laboratories'
        },
        {
            name: 'Home Healthcare Services'
        },
        {
            name: 'Traditional Health Center'
        },
        {
            name: 'Traditional Birthing Center'
        },
        {
            name: 'Maternity Center'
        },
        {
            name: 'Traditional Bone Healing Center'
        }
    ],
    Hospitals: [
        {
            name: 'Private General & Surgical Hospitals'
        },
        {
            name: 'Public General & Surgical Hospitals'
        },
        {
            name: 'Private Psychiatric & Substance Abuse Hospitals'
        },
        {
            name: 'Public Psychiatric & Substance Abuse Hospitals'
        },
        {
            name: 'Maternity Centers'
        },
        {
            name: 'Childcare Centers'
        },
        {
            name: 'Plastic & Cosmetic Surgery Centers'
        },
        {
            name: 'Opthamological Clinic'
        },
        {
            name: 'Opthopedic Hospital'
        },
        {
            name: 'Veterinary Clinic/Hospital'
        }
    ],
    'Nursing & Residential Care': [
        {
            name: 'Nursing Care Facility'
        },
        {
            name: 'Residential Mental Retardation Care Facility'
        },
        {
            name: 'Community Care Facility For Elderly'
        }
    ],
    'Social Assistance': [
        {
            name: 'Individual & Family Services'
        },
        {
            name: 'Community Food & Housing'
        },
        {
            name: 'Emergency & Relief Services'
        },
        {
            name: 'Vocational Rehabilitation Services'
        },
        {
            name: 'Child Daycare Services'
        }
    ],
    'Educational Support Services': [
        {
            name: 'Online Lessons Services'
        },
        {
            name: 'Onsite Lessons Services'
        },
        {
            name: 'One on One Lessons Services'
        },
        {
            name: 'Artisanship & Trade Lessons Services'
        }
    ],
    'Performing Arts & Spectator Sports': [
        {
            name: 'Performing Arts Services'
        },
        {
            name: 'Spectator Sports Services'
        },
        {
            name: 'Sports & Performing Arts Promotions'
        },
        {
            name: 'Artists, Athletes, Entertainers & Celebrity Managing Agencies'
        },
        {
            name: 'Independent Artists, Writers & Performers'
        }
    ],
    'Museums & Historical Sites': [
        {
            name: 'Art Museums & Galleries'
        },
        {
            name: 'Historical Houses'
        },
        {
            name: 'Historical & Cultural Museums'
        },
        {
            name: 'Plants & Animal Museums (Zoos, Aquariums)'
        },
        {
            name: 'Anatomical Museums'
        },
        {
            name: 'Sites & Memorials'
        },
        {
            name: 'War Museums'
        },
        {
            name: 'Music Museums'
        },
        {
            name: 'Open-air Museums'
        },
        {
            name: 'Virtual Museums'
        },
        {
            name: 'Sports Museums'
        },
        {
            name: 'Observatories & Planetariums'
        },
        {
            name: 'Sculpture Galleries'
        }
    ],
    'Amusement, Gambling & Betting Services': [
        {
            name: 'Sports Betting & Gambling Services'
        },
        {
            name: 'Amusement Parks & Arcades'
        },
        {
            name: 'Sports Teams & Clubs Operations'
        },
        {
            name: 'Hiking & Guiding Tours'
        },
        {
            name: 'Theme Parks'
        }
    ],
    'Accommodation Services': [
        {
            name: 'Hotels'
        },
        {
            name: 'Hostels'
        },
        {
            name: 'Bed & Breakfasts'
        },
        {
            name: 'Campsites'
        },
        {
            name: 'Guest Houses'
        },
        {
            name: 'Motels'
        },
        {
            name: 'Apartment & Shortlets'
        },
        {
            name: 'Cottages'
        },
        {
            name: 'Homestay'
        },
        {
            name: 'Chalets'
        },
        {
            name: 'Farm Stays'
        },
        {
            name: 'Water & Beachside Resorts'
        }
    ],
    'Food Services': [
        {
            name: 'Full Service Restaurants'
        },
        {
            name: 'Eateries'
        },
        {
            name: 'Bukaterias '
        },
        {
            name: 'Street food'
        },
        {
            name: 'Online Food Delivery'
        },
        {
            name: 'Home Cooking'
        },
        {
            name: 'Confectioneries'
        },
        {
            name: 'Salads, Pastries  & Sandwiches'
        }
    ],
    'Repair & Maintenance': [
        {
            name: 'Vehicle Repair & Maintenace'
        },
        {
            name: 'Electronic & Precision Equipment Repair & Maintenance'
        },
        {
            name: 'Personal & Household Goods Maintenance'
        },
        {
            name: 'Commercial & Industrial Machinery Repair & Maintenance'
        }
    ],
    'Personal & Commercial Laundry Services': [
        {
            name: 'Dry Cleaning Services'
        },
        {
            name: 'Home Cleaning Services'
        },
        {
            name: 'Office Cleaning Services '
        },
        {
            name: 'Home Laundry Services'
        },
        {
            name: 'Laundromats'
        }
    ],
    'Personal Services': [
        {
            name: 'Dating & Match Making Services'
        },
        {
            name: 'Death Care Services'
        },
        {
            name: 'Photo Finishing Services'
        },

        {
            name: 'Petcare & Training Service'
        },
        {
            name: 'Temporary Parking Services'
        },
        {
            name: 'Event Management Services'
        },
        {
            name: 'Escort Service'
        },
        {
            name: 'Photography Photofinishing Services'
        },
        {
            name: 'Hairdressing, Barbing & Grooming Services'
        },
        {
            name: 'Massages & Acupuncture Services'
        },
        {
            name: 'Weight Loss Services'
        }
    ],
    'Religious Organizations': [
        {
            name: 'Islamic Religious Organizations'
        },
        {
            name: 'Christian Religious Organizations'
        },
        {
            name: 'Traditional Religious Organizations'
        },

        {
            name: 'Other Religious Organizations'
        }
    ],

    'Employment Agencies': [
        {
            name: 'Traditional Employment Agencies'
        },
        {
            name: 'Contingency Employment Agencies'
        },

        {
            name: 'Executive Search Agencies'
        },
        {
            name: 'Temporary Staffing Agencies'
        },
        {
            name: 'Private Recruiters'
        },
        {
            name: 'Medical Staffing Agencies'
        },
        {
            name: 'Farm Staffing Agencies'
        },
        {
            name: 'Public Works Agencies'
        }
    ]
};

export default companyTypeC;
